import styled from "styled-components";

import { colors, radii, shadows } from "shared/ui/tokens";

import { MOBILE_BREAKPOINT } from "features/IikoIntegration/constants";

export const Card = styled.section`
    background: ${colors.surface};
    border-radius: ${radii.base};
    box-shadow: ${shadows.panel};
    padding: 24px;
    opacity: 0.45;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        padding: 16px;
    }
`;

export const Title = styled.h2`
    margin: 0;
    font-size: 1.0625rem;
    font-weight: 600;
    line-height: 1.2;
    color: ${colors.textPrimary};
`;

export const Description = styled.p`
    margin: 4px 0 0;
    font-size: 12px;
    color: ${colors.textSecondary};
`;
